import { Page } from '@app/ui';
import { useBool } from '@app/base';
import { ProviderSignUpPanel } from '@app/main/widgets/Providers.SignUp';
import { Form } from '@webinex/antik';
import { Alert, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

export function ProviderSignUpPage() {
  const { t } = useTranslation();
  const [submitted, , toggleSubmitted] = useBool(false);

  return (
    <Page htmlTitle={t('employees.signup.title')}>
      <Page.Body span={{ span: 12, offset: 6 }}>
        <Page.Card title={t('employees.signup.title')}>
          {submitted ? (
            <Alert className="text-multiline" type="success" message={t('employees.signup.success')} />
          ) : (
            <ProviderSignUpPanel onSubmitted={toggleSubmitted} />
          )}

          <div className="text-center">
            {!submitted && (
              <Form.Submit className="w-100" uid="signup" type="primary">
                {t('employees.signup.submit')}
              </Form.Submit>
            )}
            <div className="mt-5">
              <a href="/">{t('employees.signup.signin')}</a>
            </div>
            <Typography.Paragraph type="secondary" className="mb-0 text-center mt-2 text-small">
              <div>{t('copyright', { year: new Date().getFullYear() })}</div>
            </Typography.Paragraph>
          </div>
        </Page.Card>
      </Page.Body>
    </Page>
  );
}
